import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {Group, Item} from '@pb/kit-component-group';
import {Cell, Row} from '@pb/kit-component-table';


export const CrmRowSkeleton = () => (
    <Row>
        <Cell>
            <div className="pt-xs" style={{width: 80}}>
                <SkeletonItem width={40} height={16}/>
            </div>
        </Cell>
        <Cell>
            <Group justify="space-between">
                <Group>
                    <Item style={{width: 80}}><SkeletonItem width={70} height={28}/></Item>
                    <Item style={{width: 100}}>
                        <Group justify="end">
                            <SkeletonItem width={50} height={28}/>
                        </Group>
                    </Item>
                    <Item style={{width: 150}}>
                        <Group justify="end">
                            <SkeletonItem width={100} height={28}/>
                        </Group>
                    </Item>
                    <Item style={{maxWidth: 300}} shrink={1}>
                        <Group justify="start">
                            <SkeletonItem width={100} height={28}/>
                        </Group>
                    </Item>
                </Group>
                <Item style={{width: 30}}/>
            </Group>
        </Cell>
    </Row>
);
